import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/components.css';
import './styles/modal.css';
import AppRouter from './AppRouter';
import reportWebVitals from './reportWebVitals';

// Set data-role before first render to avoid flash.
// Login page always uses default (no role color); clear any stale role.
if (window.location.pathname.startsWith('/super-admin')) {
  document.documentElement.setAttribute('data-role', 'super-admin');
  localStorage.removeItem('anygrc_role_theme');
} else if (window.location.pathname === '/login' || window.location.pathname === '/') {
  document.documentElement.removeAttribute('data-role');
} else {
  const storedRole = localStorage.getItem('anygrc_role_theme');
  if (storedRole && storedRole.length > 0) document.documentElement.setAttribute('data-role', storedRole);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
